import UUID from './uuid.js'

// css class for disabled element
const CSS_CLASS_DISABLED = 'is--disabled'

// css class for readonly element
const CSS_CLASS_READONLY = 'is--readonly'

// css class for invalid element
const CSS_CLASS_INVALID = 'is--invalid'

// css class for warning element
const CSS_CLASS_WARNING = 'is--warning'

// merge input mixin with UUID
export default {
  mixins: [UUID],

  props: {

    id: {
      type: [String, Boolean],
      default: null,
    },

    name: {
      type: String,
      default: '',
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    invalid: {
      type: Boolean,
      default: false,
    },

    warning: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

    // @returns Object bindings
    input__bindings () {
      const bindings = {
        id: this.id === null ? this.uuid('input') : this.id,
      }

      if (this.name) {
        bindings.name = this.name
      }

      if (this.disabled) {
        bindings.disabled = true
      }

      if (this.readonly) {
        bindings.readonly = true
      }

      return bindings
    },

    // @returns Array css classes
    input__cssClasses () {
      const classes = []

      // shortcut
      if (!this.$style) {
        return classes
      }

      if (this.disabled
        && Object.prototype.hasOwnProperty.call(this.$style, CSS_CLASS_DISABLED)) {
        classes.push(this.$style[CSS_CLASS_DISABLED])
      }

      if (this.readonly
        && Object.prototype.hasOwnProperty.call(this.$style, CSS_CLASS_READONLY)) {
        classes.push(this.$style[CSS_CLASS_READONLY])
      }

      if (this.invalid
        && Object.prototype.hasOwnProperty.call(this.$style, CSS_CLASS_INVALID)) {
        classes.push(this.$style[CSS_CLASS_INVALID])
      }

      if (this.warning
        && Object.prototype.hasOwnProperty.call(this.$style, CSS_CLASS_WARNING)) {
        classes.push(this.$style[CSS_CLASS_WARNING])
      }

      return classes
    },
  },
}
